// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: fixed;
  top: 56px;
  left: 0;
  width: 220px;
  height: calc(100vh - 56px);
  background-color: #1f2937;
  padding: 16px;
  color: #ffffff;
}

.sidebar-title {
  font-size: 14px;
  text-transform: uppercase;
  margin-bottom: 12px;
  color: #9ca3af;
}

.sidebar-item {
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 6px;
  text-decoration: none;
  color: #ffffff;
}

.sidebar-item:hover {
  background-color: #374151;
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".sidebar {\n  position: fixed;\n  top: 56px;\n  left: 0;\n  width: 220px;\n  height: calc(100vh - 56px);\n  background-color: #1f2937;\n  padding: 16px;\n  color: #ffffff;\n}\n\n.sidebar-title {\n  font-size: 14px;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n  color: #9ca3af;\n}\n\n.sidebar-item {\n  padding: 10px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-bottom: 6px;\n  text-decoration: none;\n  color: #ffffff;\n}\n\n.sidebar-item:hover {\n  background-color: #374151;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
